import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InvoiceListConfigService } from '../../services/invoice-list-config/invoice-list-config.service';

@Component({
    selector: 'lib-invoice-list',
    template: `<lib-filter-list [configService]="invoiceListConfigService"></lib-filter-list>`,
    styleUrls: ['./invoice-list.component.css'],
    standalone: false
})
export class InvoiceListComponent {
  public invoiceListConfigService = inject(InvoiceListConfigService);
  protected route = inject(ActivatedRoute);

  constructor() {
    this.invoiceListConfigService.setCustomerId(
      this.route.snapshot.params['customerId']
    );
  }
}
